import React from 'react';

const EquationFinder = () => {
  return (
    <div>
      <h2>Equation Finder</h2>
      <p>
        This script employs advanced techniques to search for mathematical equations and
        constants within the 300-bit binary string of the Wow! signal. The goal is to find
        evidence of universal mathematical knowledge, which would be a strong indicator of
        an intelligent, artificial origin.
      </p>
      <h3>Analysis Methods</h3>
      <ol>
        <li>
          <strong>5-Bit Encoding Search:</strong>
          <p>
            A hypothetical 5-bit character set is used to represent letters, numbers, and
            symbols. The script then searches for the binary representations of famous
            equations like E=mc², the Pythagorean theorem, and the golden ratio equation.
          </p>
          <p>
            <strong>Result:</strong> No matches were found. This suggests that if equations
            are present, they are either encoded differently or are not among the ones
            tested.
          </p>
        </li>
        <li>
          <strong>Fractional Interpretation:</strong>
          <p>
            The 300-bit string is interpreted as a fixed-point number (specifically, with
            an 8-bit integer part and a 292-bit fractional part). The resulting decimal
            value is then compared to fundamental mathematical constants like the golden
            ratio.
          </p>
          <p>
            <strong>Result:</strong> The integer part of the binary string is 207, which is
            nowhere near the golden ratio (approx. 1.618). Thus, no match was found with
            this method.
          </p>
        </li>
      </ol>
      <h3>Interpretation</h3>
      <p>
        Although no definitive equations or constants were found with the hypothesized
        methods, this does not rule out their existence. The encoding scheme could be
        entirely different, or the message might contain other forms of information.
        Further analysis with alternative decoding models is necessary to continue the
        search for mathematical intelligence within the signal.
      </p>
    </div>
  );
};

export default EquationFinder;
